export const ipTypesOptions = [
  { value: "0", label: "p.globalIp" },
  { value: "1", label: "p.localIp" },
  { value: "2", label: "p.serverIp" },
  { value: "3", label: "p.serverName" },
  { value: "4", label: "p.country" },
];
